﻿import window from 'window';
import document from 'document';
import { saveAs } from '../../utilities/file-saver';

export const downloadAgreement = () => {

    const selectors = {
        downloadInput: '.download-agreement__btn',
    };

    const config = {
        url: '/api/orders/downloadagreement',
        disabled: 'disabled',
        contentype: 'content-type',
        blob: 'blob',
        formtype: 'application/x-www-form-urlencoded',
        octettype: 'application/octet-stream',
        jsontype: 'application/json',
        texttype: 'text/plain'
    };

    var _download = function (e) {
        const el = e.currentTarget;
        el.disabled = config.disabled;
        var url = config.url + '?agreementnumber=' + el.dataset.agreementno + '&proposalnumber=' + el.dataset.proposalnumber;

        var xhttp = new XMLHttpRequest();
        xhttp.open('GET', url, true);
        xhttp.setRequestHeader(config.contentype, config.formtype);
        xhttp.responseType = config.blob;
        xhttp.onreadystatechange = function () {
            if (xhttp.readyState == 4) {
                el.disabled = false;
                if (xhttp.status == 401) {
                    window.location.replace(this.getResponseHeader("LoginPage"));
                }
                if (xhttp.status == 200) {
                    var isJson = this.getResponseHeader(config.contentype).indexOf(config.jsontype) != -1;
                    if (isJson) {
                        var myblob = new Blob([this.response], { type: config.texttype });
                        var reader = new FileReader();
                        reader.onload = function () { alert(reader.result); }
                        reader.readAsText(myblob);
                    } else {
                        saveAs(new Blob([this.response], { type: config.octettype }), el.dataset.filename);
                    }
                }
            }
        };
        xhttp.send();
    };

    return {
        init: function () {
            const input = document.querySelectorAll(selectors.downloadInput);
            if (input.length) {
                input.forEach((element) => element.addEventListener('click', _download));
            }
        }
    };
};